import React from "react";
import { Link } from "react-router-dom";
function copyright() {
  const topFunction = () => {
    console.log("topFunction");
    // document.body.scrollTop = 0;
    // document.documentElement.scrollTop = 0;

    window.scrollTo(0, 0);
  };

  const currentYear = new Date().getFullYear();
  return (
    <section className="amit-copyright">
      <div className="container">
        <div className="row bottom-copies">
          <p className="col-lg-8 copy-footer-29">
            © 2017-{currentYear.toString().slice(2)}{" "}
            <a href="https://www.gaviralgamtec.com/" target="_blank">
              Gaviral Gamtec Private Limited
            </a>
            . All Rights Reserved.
          </p>
          {/* <div className="col-lg-4 main-social-footer-29">
            <a href="#facebook" className="facebook">
              <span className="fab fa-facebook-f"></span>
            </a>
            <a href="#twitter" className="twitter">
              <span className="fab fa-twitter"></span>
            </a>
            <a href="#pinterest">
              <span className="fab fa-pinterest-p"></span>
            </a>
            <a href="#instagram" className="instagram">
              <span className="fab fa-instagram"></span>
            </a>
          </div> */}
        </div>
      </div>
      <button onClick={() => topFunction()} id="movetop" title="Go to top">
        <i className="fas fa-level-up-alt"></i>
      </button>
    </section>
  );
}

export default copyright;
